import { useTranslation } from "react-i18next";

export function Breadcrumbs({ current }) {
  const { t } = useTranslation();
  const steps = [
    t("proxy.withdrawals.common.steps.data"),
    t("proxy.withdrawals.common.steps.items"),
    t("proxy.withdrawals.common.steps.confirmation"),
  ];

  return (
    <div className="wp:mb-8 wp:flex wp:flex-wrap wp:items-center wp:gap-2 wp:text-sm wp:font-medium wp:text-gray-500">
      {steps.map((step, index) => (
        <span key={step} className={index + 1 === current ? "wp:[color:var(--wf-text-color,#111827)]" : ""}>
          {index > 0 ? <span className="wp:mr-2 wp:text-gray-300">/</span> : null}
          {step}
        </span>
      ))}
    </div>
  );
}
